<template>
  <div class="mutil-range-slider"  :class="disabled && 'is-disabled'">
    <div class="slider-bar-container" ref="barContainer" :style="rangeNames.length > 0 && 'border: none'">
      <div
        v-for="(config, name) in rangeConfig"
        class="slider-bar-item"
        :key="name"
        :style="{backgroundColor: config.color, width: `${value[name]}%`}"
      ></div>
    </div>
    <div class="slider-btn-container">
      <div
        v-for="(btnInfo, name) in sliderBtns"
        class="slider-btn-item"
        :key="name"
        :style="btnInfo.style"
        @mousedown="onSliderBtnMouseDown($event, btnInfo, name)"
      ></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    rangeConfig: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sliderBtns: {},
      isMoving: false
    }
  },
  computed: {
    valueWatcher () {
      const value = {}
      _.forEach(this.value, (val, name) => {
        value[name] = val
      })
      return value
    },
    rangeNames () {
      const names = []
      _.forEach(this.rangeConfig, (config, name) => {
        if (config.show) {
          names.push(name)
        }
      })
      return names
    }
  },
  created () {
    this.refershBtns()
  },
  methods: {
    refershBtns () {
      if (this.isMoving) {
        return
      }
      const btns = {}
      let movedValue = 0
      let lastValue = 0
      _.forEach(this.rangeNames, (name, index) => {
        const value = this.value[name]
        if (index < 1) {
          lastValue = value
          return
        }
        movedValue += lastValue
        btns[name] = {
          btnIndex: index,
          movedValue,
          style: { left: `${Math.round(movedValue)}%` }
        }
        lastValue = value
      })
      this.sliderBtns = btns
    },
    onSliderBtnMouseDown ($event, btnInfo, name) {
      this.isMoving = true
      const names = this.rangeNames
      const btnIndex = btnInfo.btnIndex
      const lastName = names[btnIndex - 1]
      const nextName = names[btnIndex + 1]
      const nextBtn = this.sliderBtns[nextName]
      const lastBtn = this.sliderBtns[lastName]
      const barContainerEl = this.$refs.barContainer
      const containerWidth = barContainerEl.clientWidth
      let maxMoveValue = 100
      let minMoveValue = 0
      if (nextBtn) {
        maxMoveValue = nextBtn.movedValue
      }
      if (lastBtn) {
        minMoveValue = lastBtn.movedValue
      }
      let movedValue = btnInfo.movedValue
      let value = this.value[name]
      let lastValue = this.value[lastName]
      const maxValue = value + lastValue
      document.body.style.userSelect = 'none'
      document.body.style.setProperty('cursor', 'w-resize', 'important')
      document.onmousemove = (moveEvent) => {
        const move = moveEvent.movementX * 100 / containerWidth
        movedValue = _.clamp(movedValue + move, minMoveValue, maxMoveValue)
        value = _.clamp(value - move, 0, maxValue)
        lastValue = _.clamp(lastValue + move, 0, maxValue)
        btnInfo.style.left = `${Math.round(movedValue)}%`
        btnInfo.movedValue = Math.round(movedValue)
        this.value[name] = Math.round(value)
        this.value[lastName] = Math.round(lastValue)
      }

      document.onmouseup = (upEvent) => {
        document.onmousemove = null
        document.onmouseup = null
        document.body.style.userSelect = null
        document.body.style.cursor = null
        this.isMoving = false
      }
    }
  },
  watch: {
    rangeNames () {
      this.refershBtns()
    },
    valueWatcher () {
      this.refershBtns()
    }
  }
}
</script>

<style lang="scss" scoped>
.mutil-range-slider {
  &.is-disabled {
    .slider-bar-container {
      opacity: .35;
    }

    .slider-btn-container {
      display: none;
    }
  }

  .slider-bar-container {
    display: flex;
    height: 12px;
    border: 1px dashed #b2b2b2;
    border-radius: 10px;
    overflow: hidden;

    .slider-bar-item {
      margin: 0;
      border: 0;
      padding: 0;
      outline: 0;
      user-select: none;
    }
  }

  .slider-btn-container {
    margin-bottom: 20px;
    position: relative;

    .slider-btn-item {
      width: 0;
      height: 0;
      border-radius: 0;
      border: 5px solid #fff;
      border-right-color: gray;
      border-bottom-color: gray;
      border-top-width: 8px;
      border-bottom-width: 8px;
      outline: none;
      cursor: w-resize;
      position: absolute;

      &:first-child {
        margin-left: -10px;
      }

      &:not(:first-child) {
        border-left-color: gray;
        border-right-color: #fff;
      }
    }
  }
}
</style>
